var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"d-flex justify-end align-end mx-6"},[(_vm.canCreateGroupHead)?_c('CreateGroupHeadDialog'):_vm._e()],1),_c('GroupHeadDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }